import axios, { AxiosRequestConfig } from "axios";
import {
  requestInterceptor,
  requestRejectedInterceptor,
  responseInterceptor,
  responseRejectedInterceptor,
} from "./interceptors";

/**
 * 主服务器http的方法，由于各电商平台要求将订单等敏感数据存储在各自平台，所以后端分为一个主服务器，和多个平台服务器（淘宝，拼多多，京东），
 * 主服务器存储不敏感的数据，如快递单模板，平台服务器存储各个平台的敏感数据如订单、商品、运单号等，注：小平台对数据存储没要求，所以统一
 * 存储在淘宝服务器
 */
const POST_FORM_HEADERS = {
  "Content-Type": "application/x-www-form-urlencoded",
};

const axiosInstance = axios.create({
  baseURL: "https://sharebe.fahuoyi.com",
  timeout: 60000,
});

axiosInstance.interceptors.request.use(requestInterceptor, requestRejectedInterceptor);
axiosInstance.interceptors.response.use(responseInterceptor, responseRejectedInterceptor);

// normal http form post
function post<T>(urlPath, params?: any): Promise<T> {
  return axiosInstance.post(urlPath, params, { headers: POST_FORM_HEADERS }) as unknown as Promise<T>;
}

// http post with json body
function postJson<T>(urlPath, data?: any): Promise<T> {
  return axiosInstance.post(urlPath, data) as unknown as Promise<T>;
}

// http get
function get<T>(urlPath, params?: any): Promise<T> {
  return axiosInstance.get(urlPath, { params }) as unknown as Promise<T>;
}

function patch<T>(urlPath: string, data?: any, params?: AxiosRequestConfig) {
  return axiosInstance.patch<T>(urlPath, data, params) as unknown as Promise<T>;
}

export { post, postJson, get, patch };
